$(function () {
    // Select all links with hashes
    $('a[href*=#]:not([href=#])').on('click', function(e) {
        if($(this).hasClass('next-tab-arrows')) {

        } else {
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
                || location.hostname == this.hostname) {

                // get site header height
                if ($(window).width() > 768) {
                    if($(this).hasClass('nav-link')) {
                        var siteHeader = 165;
                    } else {
                        var siteHeader = 65;
                    }
                } else {
                    var siteHeader = $('.site-header').outerHeight();
                }

                if($(this).data('scroll-offset')) {
                    var siteHeader = $(this).data('scroll-offset');
                }

                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                if (target.length) {
                    setTimeout(function () {
                        // console.log('here');
                        $('html,body').animate({
                            scrollTop: target.offset().top - siteHeader
                        }, 500);
                    }, 400);
                    // return false;
                }
            }
        }
    });
});
